import { render, staticRenderFns } from "./otherNation.vue?vue&type=template&id=e5347b76&scoped=true"
import script from "./otherNation.vue?vue&type=script&lang=js"
export * from "./otherNation.vue?vue&type=script&lang=js"
import style0 from "./otherNation.vue?vue&type=style&index=0&id=e5347b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5347b76",
  null
  
)

export default component.exports